import './NotificationList.scss';
import {
    CalculationNotificationServiceName,
    OpportunityNotificationToggleServiceName
} from "../../../utils/names/serviceNames";
import {OpportunityNotificationToggleService} from "../../service/OpportunityNotificationToggleService";
import {CalculationsNotificationService} from "../../../opportunities_service/service/CalculationsNotificationService";
import {Page} from "../../../utils/models/Page";

class DynamicNotificationsList {

    private isBeingViewed: boolean;
    private PAGE_SIZE: number = 5;
    private notificationsNumber = 0;
    private firstPageHasLoaded = false;

    constructor(private notificationService: CalculationsNotificationService,
                private opportunityNotificationService: OpportunityNotificationToggleService,
                private totalElements?: number,
                private loadedPages: any[] = []) {
        notificationService.getNumberOfNotificationsObservable().subscribe(n => this.notificationsNumber = n);
        opportunityNotificationService.getToggleValueObservable().subscribe(isViewed => this.isBeingViewed = isViewed)
    }

    fetchNumItems_ = () => {
        return this.totalElements;
    };

    getItemAtIndex = (index) => {
        var pageNumber = Math.floor(index / this.PAGE_SIZE);
        var page = this.loadedPages[pageNumber];
        if (page) {
            return page[index % this.PAGE_SIZE];
        } else if (page !== null) {
            this.fetchPage(pageNumber);
        }
    };

    fetchPage = (pageNum) => {
        if (this.isBeingViewed) {
            this.loadedPages[pageNum] = null;
            this.notificationService.getNotifications(0, this.PAGE_SIZE)
                .then(resp => resp.data)
                .then((respPage) => this.handleNotificationResponse(respPage, pageNum))
                .then(this.notifyPageHasBeenViewed);
        }
    };

    getLength = () => {
        return this.totalElements;
    };

    handleNotificationResponse = (page: Page<Notification>, pageNum: number) => {
        this.firstPageHasLoaded = true;
        if (!this.totalElements) this.totalElements = page.totalElements;
        this.loadedPages[pageNum] = page.content;
        return page.content;
    };

    notifyPageHasBeenViewed = (notifications: Notification[]) => {
        let notificationsNumber = notifications.length;
        if (this.isBeingViewed) {
            this.notificationService.updateNumberOfNotifications(this.notificationsNumber = this.notificationsNumber - notificationsNumber);
        } else {
            this.notifyWhenListOpens(notifications);
        }
    };

    private notifyWhenListOpens(notifications: Notification[]) {
        let subscription = this.opportunityNotificationService.getToggleValueObservable().subscribe((val) => {
            if (val) {
                this.notifyPageHasBeenViewed(notifications);
                subscription.unsubscribe();
            }
        })
    }
}


export class NotificationList {

    static instance = {
        template: require('./NotificationList.html'),
        controller: ['$scope', '$log', OpportunityNotificationToggleServiceName, CalculationNotificationServiceName, NotificationList],
        scope: {
            activateNotificationsList: '='
        }, bindings: {
            numberOfNotifications: '=',
            toggleNotificationList: '='
        }
    };

    private toggleNotificationList: () => void;
    private numberOfNotifications: number;


    constructor(private $scope,
                private $log,
                private toggleService: OpportunityNotificationToggleService,
                private notificationService: CalculationsNotificationService) {
        this.$scope.activateNotificationsList = false;
        $log.debug('Mounting the notification list component');
    }


    $onInit = () => {
        this.$scope.dynamicNotifications = new DynamicNotificationsList(this.notificationService, this.toggleService, this.numberOfNotifications);
        this.$scope.activateNotificationsList = true;
        this.$log.debug('Finished mounting the notification list component');
    };

}